/* THE PRINT LOFT — Global View Switch (Artwork / In Room)
   Every product grid site-wide can render a .tpl-view-switch control (see
   snippets/tpl-view-switch.liquid). All instances share one state, stored
   as data-tpl-view on <html> and mirrored to localStorage. CSS keys off
   that html attribute (tpl-view-switch.css), so flipping the view never
   needs per-card JS — it survives AJAX sort swaps and infinite-scroll
   appends for free. layout/theme.liquid pre-applies the saved view before
   first paint to avoid a flash. */
(function () {
  'use strict';

  var STORAGE_KEY = 'tpl-grid-view';

  /* Fix 2026-10-05: room view fades in the collection grid's secondary image,
     which ships deferred (data-tpl-defer-src, perf 2026-09-11) and otherwise
     hydrates only on hover, focus or touch-hold. A touch device fires none of
     those, so In Room faded the artwork out and an image with no source in —
     a grid of blank cards for 90%+ of traffic. Whatever room view reveals, we
     load. Deliberately duplicated from tpl-animations.js: this file runs in
     <head>, before that one defines window.TPLHydrateDeferred, and the saved-
     view path in init() needs hydration on the very first paint. */
  var DEFER_SELECTOR = 'img[data-tpl-defer-src]';

  function hydrateImg(img) {
    var src = img.getAttribute('data-tpl-defer-src');
    if (!src) return;
    var srcset = img.getAttribute('data-tpl-defer-srcset');
    /* Hold the crossfade until the file is actually on screen. data-tpl-pending
       keeps the artwork up while the room shot downloads, so a slow connection
       sees the old image a moment longer instead of an empty frame — and a file
       that never arrives keeps the attribute, so the card falls back to the
       artwork for good rather than showing a broken image. */
    img.setAttribute('data-tpl-pending', '');
    img.addEventListener('load', function () {
      img.removeAttribute('data-tpl-pending');
    }, { once: true });
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', src);
    img.removeAttribute('data-tpl-defer-src');
    img.removeAttribute('data-tpl-defer-srcset');
    if (img.complete && img.naturalWidth > 0) img.removeAttribute('data-tpl-pending');
  }

  function currentView() {
    return document.documentElement.getAttribute('data-tpl-view') === 'room' ? 'room' : 'artwork';
  }

  /* Public: grids that arrive after first paint — sort/filter swap, infinite
     scroll — hand their new subtree here. Outside room view it is a no-op, so
     the deferred-image perf win stands for everyone still on Artwork. */
  function hydrateRoomImages(root) {
    if (currentView() !== 'room') return;
    var scope = root || document;
    if (!scope || !scope.querySelectorAll) return;
    var imgs = scope.querySelectorAll(DEFER_SELECTOR);
    for (var i = 0; i < imgs.length; i++) hydrateImg(imgs[i]);
  }

  window.TPLHydrateRoomImages = hydrateRoomImages;

  /* Single source of truth for the pending contract. tpl-animations.js hydrates
     the same images on hover / focus / touch-hold and defers to this, so both
     paths mark data-tpl-pending the same way and the CSS can trust it. */
  window.TPLHydrateImage = hydrateImg;

  function readSavedView() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function saveView(view) {
    try {
      window.localStorage.setItem(STORAGE_KEY, view);
    } catch (error) {
      /* Private mode — toggle still works for this page view */
    }
  }

  function syncSwitches(view) {
    document.querySelectorAll('[data-tpl-view-switch]').forEach(function (el) {
      el.setAttribute('data-tpl-state', view);
      el.querySelectorAll('[data-tpl-view-option]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-tpl-view-option') === view ? 'true' : 'false');
      });
    });
  }

  function applyView(view) {
    document.documentElement.setAttribute('data-tpl-view', view);
    syncSwitches(view);
    hydrateRoomImages(document);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tpl-view-option]');
    if (!button) return;
    var view = button.getAttribute('data-tpl-view-option') === 'room' ? 'room' : 'artwork';
    applyView(view);
    saveView(view);
  });

  function init() {
    applyView(readSavedView() === 'room' ? 'room' : 'artwork');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
